var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.503 10.23L1.218.077A.87.87 0 00.193.313a.833.833 0 00-.021 1.04L7.5 10.998.172 20.646a.835.835 0 00.019 1.04.859.859 0 001.025.236l22.285-10.154a.845.845 0 00.499-.769c0-.33-.194-.63-.497-.768z",
    fill: "#010118"
  })));
}

export default SvgArrowinline;